<template>
  <div class="video_box">

  </div>
</template>

<script>
export default {
  props:{
    devCode:String
  },
  watch:{
    devCode(val){
      console.log(val,'val')
      this.picFromInfo.devCode = val
      this.getTableData()
    }
  },
  data(){
    return {

    }
  },
  methods:{

  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.video_box{
  width: 860px;
  height: 510px;
  margin: 10px 0 10px 0 ;
  outline: 1px red solid;
}
</style>